import { render } from "./CliAcceptancePage.vue?vue&type=template&id=afdc1762&scoped=true&ts=true"
import script from "./CliAcceptancePage.vue?vue&type=script&lang=ts"
export * from "./CliAcceptancePage.vue?vue&type=script&lang=ts"

import "./CliAcceptancePage.vue?vue&type=style&index=0&id=afdc1762&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afdc1762"]])

export default __exports__